import { type MapProps } from '@vis.gl/react-google-maps';

import { METERS_IN_MILE } from 'Components/shared/GoogleMap/GoogleMap.consts';

import { MAX_ZOOM_LEVEL } from '../SwitchableMap.consts';

export const CIRCLE_OPTIONS: google.maps.CircleOptions = {
	fillColor: '#FEF200',
	fillOpacity: 0.2,
	radius: METERS_IN_MILE * 3,
	strokeOpacity: 0,
};

export const DEFAULT_MAP_OPTIONS: MapProps = {
	clickableIcons: false,
	disableDefaultUI: true,
	gestureHandling: 'greedy',
	keyboardShortcuts: false,
	maxZoom: MAX_ZOOM_LEVEL,
	styles: [
		{
			featureType: 'poi.business',
			stylers: [{ visibility: 'off' }],
		},
	],
};
